import React from "react";
import headerImage from "../../assets/header16.jpg";
import w16_01 from "../../assets/w16_01.jpg";
import w16_02 from "../../assets/w16_02.jpg";
import w16_03 from "../../assets/w16_03.jpg";
import w16_04 from "../../assets/w16_04.jpg";
import w16_05 from "../../assets/w16_05.jpg";
import w16_06 from "../../assets/w16_06.jpg";
import w16_07 from "../../assets/w16_07.jpg";

import w16_09 from "../../assets/w16_09.jpg";

import w16_13 from "../../assets/w16_13.jpg";
import w16_14 from "../../assets/w16_14.jpg";
import w16_15 from "../../assets/w16_15.jpg";
import w16_16 from "../../assets/w16_16.jpg";
import w16_17 from "../../assets/w16_17.jpg";
import w16_18 from "../../assets/w16_18.jpg";
import w16_19 from "../../assets/w16_19.jpg";

import w16_21 from "../../assets/w16_21.jpg";
import w16_22 from "../../assets/w16_22.jpg";

import w16_26 from "../../assets/w16_26.jpg";
import w16_27 from "../../assets/w16_27.jpg";
import w16_28 from "../../assets/w16_28.jpg";
import w16_29 from "../../assets/w16_29.jpg";
import w16_30 from "../../assets/w16_30.jpg";
import imperator from "../../assets/imperator.jpg";
import imperator_interface from "../../assets/imperator_interface.jpg";
import imperator_lens from "../../assets/imperator_lens.jpg";
import imperator_lock from "../../assets/imperator_lock.jpg";
import imperator_remote from "../../assets/imperator_remote.jpg";
import imperator_reset from "../../assets/imperator_reset.jpg";
import imperator_result from "../../assets/imperator_result.jpg";
import imperator_shutter from "../../assets/imperator_shutter.jpg";



const Assignment17 = () => {

    return (
      <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>Week 16: Wildcard Week</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">June 02, 2025</span></p>
          <div className="mt-4 flex space-x-4">
            
            </div>
            </div>
            </div>
            
      <p className="text-justify text-gray-700 mb-6">
        This week, I used the GS Laser Cutter to create both the top and bottom aluminum plates for my robot. This was a great opportunity to work with industrial equipment and learn how to cut custom metal parts from scratch.
      </p>
      <img src={imperator} alt="imperator" className="my-4 mx-auto rounded shadow-md" />
      <h2 className="text-2xl font-semibold mb-2">Our tiny metal laser cutter: GS 130130 FL aka Imperator</h2>
<ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
  <li><strong>Machine type:</strong> Fiber laser cutter</li>
  <li><strong>Model:</strong> GS 130130 FL</li>
  <li><strong>Laser power:</strong> 1.5 kW</li>
  <li><strong>Working area:</strong> 1300 × 1300 mm</li>
  <li><strong>Supported materials:</strong> Aluminum, stainless steel, mild steel, brass (depending on settings)</li>
  <li><strong>Cutting thickness:</strong> Up to 10 mm (material-dependent)</li>
  <li><strong>Positioning accuracy:</strong> ±0.03 mm</li>
  <li><strong>Software:</strong> Compatible with standard industrial laser CAM software (e.g. CypCut)</li>
  <li><strong>Safety:</strong> Enclosed housing, interlock doors, emergency stop system</li>
</ul>

<p className="text-gray-700 mb-6">
  For full specifications and details, visit the official website:{" "}
  <a
    href="https://www.gs-laser.eu/produkt/gs-130130-fl"
    target="_blank"
    rel="noopener noreferrer"
    className="text-blue-600 underline"
  >
    GS 130130 FL – Product Page
  </a>
</p>
<img src={imperator_lock} alt="imperator lock" className="my-4 mx-auto rounded shadow-md" />
<p>Here you can see the safety and power control elements of the GS 130130 FL fiber laser cutter.
On the right side, the yellow-red rotary switch is the main power switch, used to turn the machine on and off.
Mounted below the door is a red safety interlock system: this is a protective locking mechanism that immediately stops the laser operation if the door is opened during use. This safety feature ensures that the machine cannot operate while the enclosure is open, protecting the user from exposure to the laser beam.</p>
<div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">
<img src={imperator_interface} alt="imperator interface" className="my-4 mx-auto rounded shadow-md max-h-96" />
<img src={imperator_lens} alt="imperator lens" className="my-4 mx-auto rounded shadow-md max-h-96"/>

<img src={imperator_remote} alt="imperator remote" className="my-4 mx-auto rounded shadow-md max-h-96" />
</div>
<p className="text-gray-700 text-justify mb-8">
  This section shows three essential components of the GS 130130 FL laser cutting system:
  <br /><br />
  On the <strong>left</strong>, the integrated <strong>PC control panel</strong> is used to operate the laser cutter. It allows the user to load design files, adjust cutting parameters, and control the overall process. 
  <br /><br />
  In the <strong>middle</strong>, the <strong>cutting lens</strong> is displayed. This lens focuses the laser beam with high precision. It must be <strong>regularly cleaned</strong> and checked for condensation or residue after each cutting session to maintain cutting quality and prevent damage.
  <br /><br />
  On the <strong>right</strong>, the <strong>handheld remote control</strong> is shown. It enables the operator to move the laser head manually, start or stop the cutting job, and transfer files to the machine. It is especially necessary during setup and positioning tasks.
</p>
<p className="text-gray-700 mb-6">

</p>


      <h2 className="text-2xl font-semibold mb-2">Workflow</h2>
      <ul className="list-disc pl-6 space-y-1 text-gray-700 mb-4">
        <li>Export 2D sketch from Fusion 360 as <code>.dxf</code></li>
        <li>Import into the laser cutting software</li>
        <li>Material selection: Aluminum, 5 mm</li>
        <li>Adjust cutting parameters: speed, power, frequency</li>
        <li>Focus calibration before each cut</li>
        <li>Shutter and Frame</li>
        <li>Reset Machine</li>
        <li>Start cutting and monitor process</li>
      </ul>

      <p className="text-gray-700 mb-6">

</p>
<p className="text-gray-700 mb-6">

</p>
<p className="text-gray-700 mb-6">

</p>

      <h2 className="text-2xl font-semibold mb-2">Preparing the files</h2>
      I started by designing the shapes for the top and bottom plates in Fusion 360 and exported the geometry as a DXF file.
      <img src={w16_14} alt="" className="rounded-lg shadow-md mb-6" />

      <h2 className="text-2xl font-semibold mb-2">Using the Machine</h2>

<img src={w16_15} alt="" className="rounded-lg shadow-md mb-6" />
<p className="text-gray-700 mb-4">
  <strong>1) Launch CypCut:</strong> On the desktop of the laser cutter’s control PC, double-click the CypCut icon to start the software.
</p>
<img src={w16_16} alt="" className="rounded-lg shadow-md mb-6" />
<p className="text-gray-700 mb-4">
  <strong>2) Loading screen:</strong> After starting, the CypCut splash screen appears while the software loads. This may take a few seconds.
</p>
<img src={w16_26} alt="" className="rounded-lg shadow-md mb-6" />
<p className="text-gray-700 mb-4">
  <strong>3) Safety warning:</strong> A safety popup appears reminding the user to operate the machine only if trained. Confirm the dialog to proceed.
</p>
<img src={w16_27} alt="" className="rounded-lg shadow-md mb-6" />
<p className="text-gray-700 mb-4">
  <strong>4) ORG reset:</strong> You must set the machine origin ("ORG") before proceeding. Depending on the situation, choose:<br />
  – <em>ORG, then return zero point</em> or<br />
  – <em>ORG, then locate the interruption point</em> if resuming an interrupted job.<br />
  (If unsure, the first option is usually safest.)
</p>
<img src={w16_17} alt="" className="rounded-lg shadow-md mb-6" />

<p className="text-gray-700 mb-4">
  <strong>5) Open your file:</strong> Go to <em>Datei &gt; Öffnen</em> and select your cutting file, e.g. in <code>.dxf</code>, <code>.plt</code>, or <code>.bds</code> format.
</p>
<img src={w16_18} alt="" className="rounded-lg shadow-md mb-6" />
<p className="text-gray-700 mb-4">
  <strong>6) File preview:</strong> Your design will now appear in the workspace. You can check the imported paths, adjust nesting, and verify that everything looks correct before cutting.
</p>
<img src={w16_19} alt="" className="rounded-lg shadow-md mb-6" />
<p className="text-gray-700 mb-4">
  <strong>7) Calibration via BCS100:</strong> In the <em>CNC</em> tab, access the <strong>BCS100 monitor</strong>. This is used to calibrate the distance between the cutting head and the material surface. Press <em>Follow</em> or run an auto-calibration.
</p>
<img src={w16_21} alt="" className="rounded-lg shadow-md mb-6" />

<img src={w16_29} alt="" className="rounded-lg shadow-md mb-6" />
<p className="text-gray-700 mb-4">
  <strong>8–9) Confirm calibration:</strong> Once calibration is complete, you’ll see a confirmation screen indicating values like “Stability: Excellent” and “Calibrate OK.” This means the cutting head is correctly adjusted.
</p>

<p className="text-gray-700 mb-4">
  <strong>10) Material selection for the cutting layer:</strong> Click the folder icon next to the color layer (in this case, the <span className="font-semibold text-green-700">green layer</span>) to open the parameter library. Select the appropriate material preset – for example, <strong>Aluminum 4–6 mm</strong>. This loads predefined settings for gas type, pressure, speed, pierce time, and frequency curves tailored to the selected material and thickness.
</p>
      
<img src={w16_22} alt="" className="rounded-lg shadow-md mb-6" />
      
<p className="text-gray-700 mb-4">
  <strong>11) Perform a test cut:</strong> Before launching the full job, it's strongly recommended to run a short <strong>test cut</strong> on a scrap piece of the same material. This helps verify that the focus, power, and speed settings produce clean edges and full penetration. Adjust parameters if necessary before starting the final part.
</p>
     

<img src={w16_28} alt="" className="rounded-lg shadow-md mb-6" />
<img src={imperator_shutter} alt="imperator shutter" className="my-4 mx-auto rounded shadow-md max-h-96" />
      <img src={w16_09} alt="" className="rounded-lg shadow-md mb-6" />
      <p className="text-gray-700 mb-4">
  <strong>12) Final preparation and shutter activation:</strong> Once the laser head is properly aligned on the material and all parameters have been configured, <strong>close the laser’s safety door</strong>. Then, on the handheld remote control, press the <strong>“Shutter”</strong> button repeatedly until the data is correctly transmitted to the machine. This ensures the system is ready to begin the cutting process.
</p>


      <p className="text-gray-700 mb-4">
  <strong>13) Reset and start the job:</strong> Press the <strong>Reset</strong> button on the machine control panel to initialize the system and confirm readiness. After that, use the handheld remote control to <strong>start the cutting process</strong>. Make sure to monitor the machine during the initial moments to verify that the cut begins correctly and the material reacts as expected.
</p>

      
      
      
<img src={imperator_reset} alt="imperator reset" className="my-4 mx-auto rounded shadow-md" />

<p className="text-gray-700 mb-4">
  <strong>14) Cutting process and safety notice:</strong> After starting, the laser cutter will process the loaded file and cut the desired shape from the metal sheet. The process can be repeated as needed to produce additional parts. <strong>Important:</strong> Always wait until the metal has cooled down before handling it. If immediate removal is necessary, wear appropriate <strong>heat-resistant gloves</strong> to prevent burns.
</p>


      <img src={w16_03} alt="" className="rounded-lg shadow-md mb-6" />
      <img src={w16_30} alt="" className="rounded-lg shadow-md mb-6" />
      <h2 className="text-2xl font-semibold mb-2">Post-processing</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 items-center">
      <img src={w16_06} alt="" className="rounded-lg shadow-md mb-6 max-h-96" />
      <img src={w16_07} alt="" className="rounded-lg shadow-md mb-6 max-h-96" />
      <img src={w16_13} alt="" className="rounded-lg shadow-md mb-6 max-h-96" />
      </div>
      <p className="text-gray-700 mb-6">
  Since we didn't use any shielding gas like nitrogen during cutting, the aluminum got extremely hot. As a result, it behaved almost like it was being welded – the parts didn’t simply fall out as expected. Instead, I was greeted by stubborn connections and fused edges!  
  <br /><br />
  So, hammer in hand and a metal file ready, I carefully knocked the parts out of the sheet and ground away the excess material. Bit by bit, I worked my way through each edge until the shapes finally matched my designs. It was loud, a bit messy, and required patience, but I succeded.  
  <br /><br />
</p>
<p className="text-gray-700 mb-6">
  The final aluminum plates are not just shiny – they're also incredibly sturdy and well-suited to carry heavy loads. That makes them ideal for my robot platform, which is designed to transport larger components or equipment. Thanks to the precise laser cutting (and a bit of elbow grease during post-processing), I now have a solid foundation that’s both functional and reliable.
</p>
      <img src={w16_05} alt="" className="rounded-lg shadow-md mb-6" />
      <img src={w16_02} alt="" className="rounded-lg shadow-md mb-6" />
      <img src={w16_01} alt="" className="rounded-lg shadow-md mb-6" />
      

            <h2 className="text-2xl font-bold text-left mb-2">Downloads</h2>

<a
style={{ display: "block" }}
href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Top_Plate_v2.dxf"
download
>
📎 Download Top Plate
</a>
<a
style={{ display: "block" }}
href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Bottom_Plate_v2.dxf"
download
>
📎 Download Bottom Plate
</a>
            </div>

            
    );
  };
  
  export default Assignment17;
  

  

<h2 className="text-3xl font-bold mb-4"></h2>